import React from 'react';

const TelegramIcon = ({ ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="57" height="57" viewBox="0 0 57 57" fill="none" { ...rest }>
      <g clipPath="url(#clip0_1159_1187)">
        <path d="M28.5 57C44.2401 57 57 44.2401 57 28.5C57 12.7599 44.2401 0 28.5 0C12.7599 0 0 12.7599 0 28.5C0 44.2401 12.7599 57 28.5 57Z" fill="#34AADF"/>
        <path d="M11.8616 28.2526C11.8616 28.2526 26.1116 22.4044 31.0537 20.3451C32.9483 19.5215 39.3731 16.8856 39.3731 16.8856C39.3731 16.8856 42.3384 15.7325 42.0913 18.533C42.0089 19.6862 41.3499 23.7223 40.691 28.0879C39.7025 34.2657 38.6317 41.0199 38.6317 41.0199C38.6317 41.0199 38.467 42.9145 37.0667 43.244C35.6665 43.5734 33.36 42.0908 32.9483 41.7613C32.6187 41.5142 26.7705 37.8075 24.6289 35.9954C24.0523 35.5012 23.3933 34.5128 24.7112 33.3596C27.6766 30.6414 31.2184 27.2642 33.36 25.1226C34.3485 24.1341 35.3369 21.8278 31.2184 24.6283C25.3702 28.6645 19.6043 32.4535 19.6043 32.4535C19.6043 32.4535 18.2864 33.2772 15.8153 32.5358C13.3441 31.7946 10.4612 30.8061 10.4612 30.8061C10.4612 30.8061 8.48443 29.5706 11.8616 28.2526Z" fill="white"/>
      </g>
      <defs>
        <clipPath id="clip0_1159_1187">
          <rect width="57" height="57" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  );
};

export default TelegramIcon;